module.exports = __webpack_public_path__ + "static/media/close.3b6ebf20.svg";